<template>
    <div class="tree-box  main-box">
      <div class="area-tree">
        <div class="tree-box">
          <div class="tree-header" @click="clickTop">
            组织机构
          </div>
          <div class="zTreeDemoBackground left">
            <ul :id="treeId" class="ztree"></ul>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
  import '../../../../static/js/jquery-3.7.1'
  import "../../../../plugins/zTree/js/jquery.ztree.core.min.js";
  import "../../../../plugins/zTree/js/jquery.ztree.excheck.min.js";

  export default {
    name: 'menuTree',
    props: ['treeId'],
    data() {
      return {
        project_id: '',
        org_list: [],
        selected_id: '-1',
        setting:{
          data:{
            simpleData:{
              enable: true,
              idKey: "id",
              pIdKey: "p_id",
              rootPId: 0
            }
          },
          view: {
            showIcon: false
          },
          edit: {
            drag: {
              // 打开复制功能，Ctrl+鼠标左键点击后拖拽
              isCopy: true,
              // 打开移动功能，鼠标左键点击后拖拽
              isMove: true
            },
            // 打开编辑
            enable: true,
            // 关闭删除
            showRemoveBtn: false,
            // 关闭修改名称
            showRenameBtn: false
          },
          callback: {
            // 树的点击事件
            onClick: this.zTreeOnClick,
            // 拖拽结束事件
            onDrop: this.zTreeOnDrop
          }
        },
        zNodes: [],
        treeObj: new Object(),

      }
    },
    created(){
      if(this.treeId === null || this.treeId === '' || this.treeId === undefined){
        this.treeId = 'orgTreeDemo';
      }
      this.init();
    },
    methods: {
      init() {
        this.$nextTick(()=>{
          this.initDeptTree();
        })
      },
      editSelect:function(){
        this.initDeptTree();
      },
      //刷新
      refresh:function(){
        this.initDeptTree();
      },
      //初始化部门树
      initDeptTree: function(){
        return this.request({
          method:'post',
          url:'/web/service',
          params:{
            'method':'tCoreOrg_getZtreeData'
          }
        }).then((response) =>{          //这里使用了ES6的语法   //请求成功返回的数据
          if (response.code === 0) {
            let list = response.rows;
            if(list == null || list == '' || list == undefined || list.length < 0){
              return false;
            }
            //循环遍历，根据部门级别显示图标
            for(let i = 0 ; i < list.length ; i ++){
              if(list[i].node_level == '1'){
                // list[i].icon = require('../../../../static/img/web.png');
              }else if(list[i].node_level == '3'){
                // list[i].icon = require('../../../../static/img/agent.png');
              }else if(list[i].node_level == '4'){
                // list[i].icon = require('../../../../static/img/business.png');
              }
            }

            this.zNodes = list;
            this.treeObj = $.fn.zTree.init($("#" + this.treeId), this.setting, this.zNodes);

            let nodes = this.treeObj.getNodes();
            //默认展开所有节点
            this.treeObj.expandAll(true);

            //选中第一个节点
            // this.treeObj.selectNode(nodes[0], true);
            // this.selected_id = nodes[0].id;
            //根据节点加载右侧的数据table
            this.$emit('listenTochildEvent',nodes[0].id)
          }
        })
      },
      //树的点击事件
      zTreeOnClick:function(event, treeId, treeNode){
        if(treeNode.id != null && treeNode.id != '' && treeNode.id != undefined){
          this.selected_id = treeNode.id;
          //根据节点加载右侧的数据table
          this.$emit('listenToChildEvent',treeNode.id)
        }
      },
      //拖拽结束事件
      zTreeOnDrop:function(event, treeId, treeNodes, targetNode, moveType){
        alert(treeNodes.length + "," + (targetNode ? (targetNode.tId + ", " + targetNode.name) : "isRoot" ));
      },
      freshArea:function(){
        $.fn.zTree.init($("#" + this.treeId), this.setting, this.zNodes);
      },
      //添加根目录
      addRoot: function () {
        this.$emit('handleAddOpenDialog',"-1")
      },
      //点击【组织机构】
      clickTop:function(){
        this.selected_id = '-1';
        //取消所有选择的几点
        this.treeObj.cancelSelectedNode();
        //根据节点加载右侧的数据table
        this.$emit('listenToChildEvent', "-1");
      },
      //添加子目录
      addChild: function () {
        if(this.selected_id == null || this.selected_id == undefined || this.selected_id == ''){
          this.$message.error("请选择需要添加的节点！");
          return false;
        }
        this.$emit('handleAddOpenDialog', this.selected_id)
      },
      //删除菜单
      deleteItem:function(){
        let treeObj = $.fn.zTree.getZTreeObj("" + this.treeId);
        let nodes = treeObj.getSelectedNodes();

        if(nodes.length < 1){
            this.$message.error("请选择需要删除的节点！");
            return false;
        }
        if(nodes.length > 1){
          this.$message.error("有且只能选择一个节点进行删除！");
          return false;
        }
        let select_node = nodes[0];

        if(select_node.children && select_node.children.length > 0){
          this.$message.error("该节点有子节点，不能删除！");
          return false;
        }
        this.$confirm(`确定进行删除操作?`, '提示',{confirmButtonText: '确定', cancelButtonText: '取消',type: 'warning'}).then(() => {
          return this.request({
            method:'post',
            url:'/web/service',
            params:{
              'method':'tCoreMenu_delete',
              'id': select_node.id
            }
          }).then((response) =>{          //这里使用了ES6的语法
            // 请求成功返回的数据
            //如果返回编码不为0，提示失败语
            if(response.code != '0'){
              this.$message.error(response.msg);
              return false;
            }
            this.$message({message: '操作成功', type: 'success', duration: 1500, onClose: () => {
                //执行成功后的操作
                //删除掉某个节点
                treeObj.removeNode(select_node);
              }
            })
          })
        }).catch(() => {})
      }
    },
  }
</script>

<style>
  @import '../../../../plugins/zTree/css/zTreeStyle/zTreeStyle.css';
</style>



// WEBPACK FOOTER //
// src/views/sys/org/org-tree.vue